type FlowEdgeWithSourceHandle = {
  sourceHandle?: unknown;
};

type FlowDiagramWithEdges = {
  edges?: FlowEdgeWithSourceHandle[] | null;
};

export function encodeAwsJsonSourceHandle(value: unknown): string | null {
  if (value === null || typeof value === "undefined") {
    return null;
  }

  if (typeof value === "string") {
    try {
      JSON.parse(value);
      return value;
    } catch {
      return JSON.stringify(value);
    }
  }

  return JSON.stringify(value);
}

export function encodeFlowDiagramSourceHandles<
  T extends FlowDiagramWithEdges | null | undefined
>(flowDiagram: T): T {
  if (!flowDiagram?.edges) {
    return flowDiagram;
  }

  return {
    ...flowDiagram,
    edges: flowDiagram.edges.map((edge) => ({
      ...edge,
      sourceHandle: encodeAwsJsonSourceHandle(edge.sourceHandle),
    })),
  } as T;
}
